export function isRelyCommandPreviewEnabled({
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  flag = process.env.REACT_APP_RELY_COMMAND_PREVIEW,
} = {}) {
  const isDevelopmentHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === 'app-dev.rely.business';

  return flag === 'true' && isDevelopmentHost;
}
